import React from 'react';

import {Link} from 'react-router';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {getElapsedTime} from 'app/general/dates';
import {gt} from 'app/utils/i18n';

import {NormalizedSignoffDataType} from '../types';
import {normalizeSignoffData} from '../utils';

import type {SignoffSerializedType} from 'sweet-types';

type Props =
  | {
      signoff: SignoffSerializedType;
      signoffData?: never;
    }
  | {signoff?: never; signoffData: NormalizedSignoffDataType};

export function PreviousVersionIndicator(props: Props): null | JSX.Element {
  const signoffData =
    props.signoffData != null
      ? props.signoffData
      : normalizeSignoffData(props.signoff);

  return signoffData.signedAt == null ? null : (
    <span className="small text-nowrap">
      {signoffData.signedVersionHTMLURL != null ? (
        signoffData.signedVersionIsCurrent ||
        signoffData.signedVersionApprovedAt == null ? null : (
          <Link
            to={signoffData.signedVersionHTMLURL}
            className="p-1 my-1 alert alert-warning"
          >
            <LazyTooltip
              tooltip={gt(
                'Approved %s',
                getElapsedTime(signoffData.signedVersionApprovedAt)
              )}
              hide={signoffData.signedVersionApprovedAt == null}
            >
              <span>{gt('Previous version')}</span>
            </LazyTooltip>
          </Link>
        )
      ) : null}
    </span>
  );
}
